import { render, staticRenderFns } from "./TagMetadata.vue?vue&type=template&id=a148027c&scoped=true"
import script from "./TagMetadata.vue?vue&type=script&lang=js"
export * from "./TagMetadata.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TagMetadata.vue?vue&type=style&index=1&id=a148027c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a148027c",
  null
  
)

export default component.exports